import React from 'react';
import ContactUs from './ContactUs';
import { get } from 'Language';

const FooterLinks = () => (
    <div className="container footer hidden-xs">
        <hr />
        <div className="row">
            <div className="col-md-3">
                <h4>WRIGHTBALANCE</h4>
                <ul className="nav">
                    <li>
                        <a href="">Golf</a>
                    </li>
                    <li>
                        <a href="">Baseball</a>
                    </li>
                    <li>
                        <a href="">Cycling</a>
                    </li>
                    <li>
                        <a href="">Hockey</a>
                    </li>
                    <li>
                        <a href="">Hiking/Treking</a>
                    </li>
                    <li>
                        <a href="">Tennis</a>
                    </li>
                    <li>
                        <a href="">Board Sports</a>
                    </li>
                </ul>
            </div>
            <div className="col-md-5">
                <h4>Wright Balance World Headquarters</h4>

                <div>
                    Southern CA, USA <br /><br />
                </div>

                <ul className="nav">
                    <li>
                        <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    </li>
                    <li>
                        <a href="/user-agreement" target="_blank" rel="noopener noreferrer">User Agreement</a>
                    </li>
                </ul>
            </div>
            <div className="col-md-4">
                <h4>{ get('CONTACT_US_TITLE') }</h4>
                <ContactUs/>
            </div>
        </div>
    </div>
)

export default FooterLinks;


// WEBPACK FOOTER //
// ./src/partials/FooterLinks.js